<template>
  <div>
    <div
      :id="id"
      :class="className"
      :style="{ height: height, width: width }"
    />
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '170px'
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    data() {
      this.initChart();
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function() {
      var that = this;
      var docChart = document.getElementById(that.id);

      // 配置图表主题
      var chart = echarts.init(docChart);

      var option = {
        // title: {
        //   top: 20,
        //   text: '请求总数量',
        //   textStyle: {
        //     fontWeight: 'normal',
        //     fontSize: 15
        //     // color: '#F1F1F3'
        //   },
        //   left: '1%'
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              // color: '#fff'
            }
          }
        },
        legend: {
          data: that.data.legend,
          top: 10,
          icon: 'roundRect',
          itemWidth: 20,
          itemHeight: 11,
          itemGap: 13,
          right: '7%',
          textStyle: {
            fontSize: 12
            // color: '#fff'
          }
        },
        grid: {
          top: '20%',
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        // 保存为图片
        // toolbox: {
        //   top: 4,
        //   right: '1.5%',
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          bottom: '5%',
          data: that.data.labels,
          axisLine: {
            lineStyle: {
              // color: '#fff'
            }
          },
          axisLabel: {
            interval: 0, color: '#606266',
            textStyle: {
              fontSize: 10 // 更改坐标轴文字大小
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              // color: '#fff'
            }
          },
          max: that.getMaxVal(that.data.values)
        },
        series: [
          {
            data: that.data.values,
            name: '数量',
            type: 'line',
            stack: '总量',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              width: 0
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFBF00' },
                { offset: 1, color: '#E03E4C' }
              ])
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#FFBF00' },
                  { offset: 1, color: '#E03E4C' }
                ])
              }
            }
          }
        ]
      };

      chart.clear();
      chart.setOption(option);
    },
    getMaxVal(arr) {
      var maxVal = 0
      for (let index = 0; index < arr.length; index++) {
        const item = arr[index]
        if (item > maxVal) {
          maxVal = item
        }
      }
      maxVal += 1
      // 如果是单数
      if (maxVal % 2 !== 0) {
        maxVal += 1
      }
      if (maxVal < 4) {
        maxVal = 4
      }
      return maxVal
    }
  }
};
</script>
